import Vue from 'vue'
import SupplierOrHiringEmployeeMixin from '@/mixins/SupplierOrHiringEmployeeMixin'
import PermissionMixin from '@/mixins/Permissions'
import IsMobileMixin from '@/mixins/Mobile'
import RequestMixin from '@/mixins/RequestMixin'
import PortalVue from 'portal-vue'
import VModal from 'vue-js-modal'
import GmapVue from 'gmap-vue'
import type CustomWindow from '@/misc/custom-window'
import { PiniaVuePlugin } from 'pinia'

declare const window: CustomWindow

Vue.mixin(PermissionMixin)
Vue.mixin(SupplierOrHiringEmployeeMixin)
Vue.mixin(IsMobileMixin)
Vue.mixin(RequestMixin)

Vue.use(PiniaVuePlugin)

Vue.use(VModal, {
  dynamicDefaults: {
    injectModalsContainer: true,
    draggable: true,
  }
})

Vue.use(PortalVue)

Vue.use(GmapVue, {
  load: {
    key: window.gmaps_api_key,
    libraries: 'places',
    region: 'NL',
    language: 'nl',
    loading: 'async'
  },

  // [OPTIONAL] If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autoBindAllEvents: false,

  // [OPTIONAL] If you want to manually install components, e.g.
  // import {GmapMarker} from 'gmap-vue/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.config.productionTip = false

export default Vue
